import React, { useState, useEffect }  from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import 'tailwindcss/tailwind.css';
import AreaSelectBox from '../dropdowns/AreaSelectBox';
import { viewJobs, clearJobRoutes, setLoading } from '../../features/billing/billingSlice';
import HeaderTitleBar from '../HeaderTitleBar';
import FormDatePicker from '../formHelpers/FormDatePicker';
import { formatDateToMMDDYYYY } from '../../utils/TextTools';
import { formatEnumKey } from '../../utils/TextTools';

const ViewJobs = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const [qParams] = useSearchParams();

  const vData = JSON.parse(localStorage.getItem('view_jobs'))

  const [selectedStartDate, setSelectedStartDate] = useState(vData?.startDate ? new Date(vData.startDate) : new Date());
  const [selectedEndDate, setSelectedEndDate] = useState(vData?.endDate ? new Date(vData.endDate) : new Date());

  const { loading } = useSelector((state) => state.billing)

  // const [selectedStartDate, setSelectedStartDate] = useState(new Date('2024-05-07'));
  // const [selectedEndDate, setSelectedEndDate] = useState(new Date('2024-05-28'));

  const [selectedAreaId, setSelectedAreaId] = useState(vData?.areaId || 1);
  const { data: jobs } = useSelector((state) => state.billing);

  const [formData, setFormData] = useState('')

  const handleStartChange = (date) => {
    setSelectedStartDate(date);
  }

  const handleEndChange = (date) => {
    setSelectedEndDate(date);
  }

  const handleAreaChange = (event) => {
    setSelectedAreaId(event.target.value)
  }

  const handleViewJobs = () => {
    localStorage.setItem('view_jobs', JSON.stringify({
      startDate: selectedStartDate,
      endDate: selectedEndDate,
      areaId: selectedAreaId
    }))

    dispatch(viewJobs({
      startDate: selectedStartDate,
      endDate: selectedEndDate,
      areaId: selectedAreaId
    }));
  }

  // useEffect(() => {
  //   dispatch(clearJobRoutes())
  // }, [location.pathname])


  const handleDelete = () => {

  }

  const filteredJobs = (tech_id) => {
    return jobs.jobs.filter(t => t.tech_id === tech_id)
  }

  const filterEnumById = (enum_list, id) => {
    let value = Object.keys(enum_list).find(k => enum_list[k] === id);
    return formatEnumKey(value);
  }

  return (
    <>
      <div className="p-4 mb-6 bg-white shadow rounded-lg">
         <HeaderTitleBar
          title='View Jobs'
          showBtn={false}
        />

        <div className="md:w-1/4 sm:w-full mt-6 items-left">

            <AreaSelectBox
              label={'Area'}
              name={'area_id'}
              value={selectedAreaId}
              onChange={handleAreaChange}
              useTarget={false}
              horizontal={true}
            />

          <FormDatePicker
            label={'Start Date'}
            name="start_date"
            onChange={handleStartChange}
            placeholder="Enter a Start Date"
            value={selectedStartDate}
            horizontal={true}
          />


          <FormDatePicker
            label={'End Date'}
            name="end_date"
            onChange={handleEndChange}
            placeholder="Enter an End Date"
            value={selectedEndDate}
            horizontal={true}
          />

          <div className="flex md:items-center mb-6">
            <button onClick={handleViewJobs} className="bg-blue-600 text-white px-4 p-1">View Jobs</button>
          </div>

        </div>
      </div>

      {loading && (
        <div role="status">
        <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
        </svg>
        <span class="sr-only">Loading...</span>
        </div>
      )}

      {(jobs && jobs?.techs && jobs.techs.length > 0) && (
        <table className="min-w-full divide-y divide-gray-200 bg-white border-gray-200 border-solid border-b-1">
          <tbody>
            {jobs.techs.map((tech, index) => (
              <tr key={index}>
                <td>
                  <table className='w-full'>
                    <tbody>
                      <tr>
                        <td colSpan="6" className='p-2 text-gray-800 bg-gray-200'>
                          {tech.tech_id}::{tech.techname}
                        </td>
                      </tr>
                      <tr className='bg-blue-600 font-normal'>
                        <td className='p-2 font-semibold text-sm text-white'>Date</td>
                        <td className='p-2 font-semibold text-sm text-white'>Job</td>
                        <td className='p-2 font-semibold text-sm text-white'>Dispatch Status</td>
                        <td className='p-2 font-semibold text-sm text-white'>Bill Status</td>
                        <td className='p-2 font-semibold text-sm text-white'>Customer Address</td>
                        <td className='p-2 font-semibold text-sm text-white text-center'>Options</td>
                      </tr>
                      {filteredJobs(tech.tech_id).map((job, jobidx) => (
                          <tr key={`job-${jobidx}`}>
                            <td className='p-2 text-xs'>{job.job_date}</td>
                            <td className='p-2 text-xs'>
                              <Link
                                to={`/billing/job_details/${job.id}?referral=${location.pathname}`}
                                className="font-medium text-blue-600 dark:text-blue-500 hover:underline">
                                  {localStorage.getItem('msoId') === '4' || localStorage.getItem('msoId') === '3' ? (
                                    job.account_number
                                  ) : (
                                    job.job_number
                                  )}
                                </Link>
                            </td>
                            <td className='p-2 text-xs'>{filterEnumById(jobs.statuses, job.status)}</td>
                            <td className='p-2 text-xs'>{filterEnumById(jobs.billing_statuses, job.billing_status)}</td>
                            <td className='p-2 text-xs'>{job.address}</td>
                            <td className='p-2 text-xs text-center'>
                              <button
                                onClick={() => handleDelete(job.id)}
                                className="text-xs text-white font-bold"
                              >
                                <svg className="h-4 w-4 text-red-500"  width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                  <path stroke="none" d="M0 0h24v24H0z"/>
                                  <line x1="4" y1="7" x2="20" y2="7" />
                                  <line x1="10" y1="11" x2="10" y2="17" />
                                  <line x1="14" y1="11" x2="14" y2="17" />
                                  <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                                  <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                                </svg>
                              </button>

                            </td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
};

export default ViewJobs;